/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Approvals_DescInputs */

const en_mk_team_approvals_desc = /** @type {(inputs: Mk_Team_Approvals_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On your computer, agents can be told to ask before risky commands or before every command. If nobody answers in time, the command is declined.`)
};

const id_mk_team_approvals_desc = /** @type {(inputs: Mk_Team_Approvals_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di komputermu, agent bisa diminta bertanya dulu sebelum perintah berisiko atau setiap perintah. Kalau tidak dijawab sampai batas waktu, perintah ditolak.`)
};

/**
* | output |
* | --- |
* | "On your computer, agents can be told to ask before risky commands or before every command. If nobody answers in time, the command is declined." |
*
* @param {Mk_Team_Approvals_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_approvals_desc = /** @type {((inputs?: Mk_Team_Approvals_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Approvals_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_approvals_desc(inputs)
	return en_mk_team_approvals_desc(inputs)
});